import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use instant scroll to avoid race conditions with layout/resize
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
